import { CardActionArea } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import { StyledCardContentDescription, StyledCardMedia } from "@framework/styled";
import type { IContract } from "@framework/types";
import { RichTextDisplay } from "@dzambalaorg/mui-rte";
import { Card } from "@dzambalaorg/ui-kit";

interface IRaffleListItemProps {
  contract: IContract;
}

export const RaffleListItem = (props: IRaffleListItemProps) => {
  const { contract } = props;

  return (
    <Card>
      <CardActionArea component={RouterLink} to={`/raffle/contracts/${contract.id}/view`}>
        <Card.Header title={contract.title} />
        <StyledCardMedia image={contract.imageUrl} title={`${contract.title}`} />
        <Card.Content>
          <StyledCardContentDescription>
            <RichTextDisplay data={contract.description} />
          </StyledCardContentDescription>
        </Card.Content>
      </CardActionArea>
    </Card>
  );
};
